/**
 * Policy API service
 */
import { getApiConfig } from '../utils/apiUtils';
import axios from 'axios';

const API_BASE = '/configuration/api/policies';

/**
 * Fetch all policies
 */
export const fetchAllPolicies = async () => {
  const response = await axios.get(`${API_BASE}/`, getApiConfig());
  return response.data;
};

/**
 * Fetch policies by type
 */
export const fetchPoliciesByType = async (policyType) => {
  const response = await axios.get(`${API_BASE}/?policy_type=${policyType}`, getApiConfig());
  return response.data;
};

/**
 * Fetch a specific policy by ID
 */
export const fetchPolicyById = async (policyId) => {
  const response = await axios.get(`${API_BASE}/${policyId}/`, getApiConfig());
  return response.data;
};

/**
 * Create a new policy
 */
export const createPolicy = async (policyData) => {
  const response = await axios.post(`${API_BASE}/`, policyData, getApiConfig());
  return response.data;
};

/**
 * Update an existing policy
 */
export const updatePolicy = async (policyId, policyData) => {
  const response = await axios.put(`${API_BASE}/${policyId}/`, policyData, getApiConfig());
  return response.data;
};

/**
 * Delete a policy
 */
export const deletePolicy = async (policyId) => {
  const response = await axios.delete(`${API_BASE}/${policyId}/`, getApiConfig());
  return response.data;
};

